/**
 * BS_DT checkout popup A/B test (Amplitude flag bs_dt-pop-up).
 *
 *   control:   unchanged, the popup blocks checkout while the BS_DT criteria are unmet.
 *   treatment: no popup, checkout proceeds.
 *
 * The client is created and fetched on page load only so the checkout click can decide
 * synchronously; nothing here reads the variant or logs exposure. Both happen in
 * window.villoidBsdtPopupVariant(), which assets/dt-cart-popup.js calls at the one point the
 * variants diverge: the checkout click where the cart has a live BS_DT item and the criteria
 * are unmet. Exposure is sent explicitly: the SDK caches one client per deployment key, and the
 * first script to create it decides automaticExposureTracking.
 *
 * Anything but a fetched 'treatment' is control: no SDK, no fetch yet, flag off or missing.
 * The SDK sends no exposure for a fallback variant, so those clicks stay out of the test.
 *
 * QA: ?bsdt_popup=treatment|control forces a variant (kept in localStorage, no exposure),
 * ?bsdt_popup=clear drops it.
 *
 * Cleanup: delete this file, its script tag in snippets/dt-cart-popup.liquid and the
 * villoidBsdtPopupVariant check in assets/dt-cart-popup.js.
 */
(function () {
  var FLAG_KEY = 'bs_dt-pop-up';
  var DEPLOYMENT_KEY = 'client-8fqJ5ArVAFM5z9c8R28C2hoCqKQyUMQe';
  var OVERRIDE_KEY = 'bsdt_popup_variant_override';
  var URL_PARAM = 'bsdt_popup';

  var client = null;

  function isVariant(v) {
    return v === 'control' || v === 'treatment';
  }

  function syncUrlOverride() {
    try {
      var v = new URLSearchParams(window.location.search).get(URL_PARAM);
      if (isVariant(v)) localStorage.setItem(OVERRIDE_KEY, v);
      if (v === 'clear') localStorage.removeItem(OVERRIDE_KEY);
    } catch (e) {}
  }

  function readOverride() {
    try {
      var v = localStorage.getItem(OVERRIDE_KEY);
      return isVariant(v) ? v : null;
    } catch (e) {
      return null;
    }
  }

  function waitFor(predicate, callback, maxAttempts, interval) {
    var attempts = 0;
    (function check() {
      if (predicate()) return callback();
      if (++attempts > maxAttempts) return;
      setTimeout(check, interval);
    })();
  }

  function initClient() {
    try {
      client = window.Experiment.initializeWithAmplitudeAnalytics(DEPLOYMENT_KEY, {
        serverZone: 'EU',
        automaticExposureTracking: false
      });
    } catch (e) {
      console.warn('[bsdt-popup-ab] Experiment init failed:', e);
      return;
    }
    client.fetch();
  }

  // Treatment leaves the page on the same click, before the SDK's 1s send interval: without a
  // beacon flush its $exposure dies in the queue while control's goes out, skewing the split.
  // Deferred to the end of the click so it also carries what later handlers of that click track
  // (bsdt_popup_not_shown, the data-event checkout_clicked); the page lives until checkout responds.
  function flushBeforeCheckout() {
    try {
      if (window.amplitude && typeof window.amplitude.setTransport === 'function') {
        window.amplitude.setTransport('beacon');
        window.amplitude.flush();
      }
    } catch (e) {}
  }

  function fetchedVariant() {
    if (!client) return 'control';
    var result = client.variant(FLAG_KEY);
    try {
      client.exposure(FLAG_KEY);
    } catch (e) {}
    return result && result.value === 'treatment' ? 'treatment' : 'control';
  }

  function variantAtDecision() {
    var variant = readOverride() || fetchedVariant();
    if (variant === 'treatment') setTimeout(flushBeforeCheckout, 0);
    return variant;
  }

  syncUrlOverride();
  window.villoidBsdtPopupVariant = variantAtDecision;
  waitFor(function () { return !!window.Experiment; }, initClient, 100, 200);
})();
